import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { BadgeCell } from '~/components/common';

import { formatNumber } from '~/utils/common';
import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';
import { type TypeReceiveStatusDetailStatus } from '~/constants/receive';

import { RECEIVE_STATUS_DETAIL_STATUS_COLOR_MAP } from './receiveBadgeColorMaps';

import type { Type3PLReceiveStatusDetail } from '~/types/receive.types';

type Type3PLReceiveStatusDetailItem = Type3PLReceiveStatusDetail['items'][number];

const countColumn = (
  accessorKey: 'requestedQty' | 'receivedQty',
  header: string,
  size: number
): TypeTableColumn<Type3PLReceiveStatusDetailItem> => ({
  accessorKey,
  header,
  size,
  cell: ({ getValue }) => {
    const value = getValue<number | null>();
    return value ? formatNumber(value) : '-';
  },
  meta: { cellStyle: { textAlign: 'right' } },
});

/**
 * [입고관리 > 입고현황 (3PL)] 입고 현황 상세 모달 > 입고 처리 상세 테이블
 */
const getReceiveStatusDetail3PLColumnDefs = () => {
  const columnDefs: TypeTableColumn<Type3PLReceiveStatusDetailItem>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'status',
      header: '작업상태',
      size: 92,
      cell: ({ getValue }) => (
        <BadgeCell
          value={getValue<TypeReceiveStatusDetailStatus>()}
          colorMap={RECEIVE_STATUS_DETAIL_STATUS_COLOR_MAP}
          variant="light"
          status
        />
      ),
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 140,
    },
    {
      accessorKey: 'goodsName',
      header: '상품명',
      minSize: 240,
      meta: { flex: true },
    },
    countColumn('requestedQty', '요청수량', 80),
    countColumn('receivedQty', '입고완료수량', 98),
    {
      accessorKey: 'receivedDate',
      header: '입고확정일시',
      size: 178,
      cell: ({ getValue }) => formatDate(getValue<string>(), DATE_FORMAT.DATE_TIME) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getReceiveStatusDetail3PLColumnDefs;
